import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@app/hooks';
import SafeHTML from '@/utils/safeHTML';
import { VmoFootnoteContainer } from './VmoFootnote.styles';

export const VmoFootnote: React.FC = () => {
  const location = useLocation();
  const templateConfig = useAppSelector((state) => state.TemplateConfig);
  const loanApplication = useAppSelector((state) => state.LoanApplication);

  const getVmoStepFromUrl = (): number => {
    const path = location.pathname;
    if (path.includes('/vmo') && !path.includes('/vmo-line-amount') && !path.includes('/vmo-draw-amount')) {
      return 0;
    } else if (path.includes('/vmo-line-amount')) {
      return 1;
    } else if (path.includes('/vmo-draw-amount')) {
      return 2;
    }
    return -1; // not a VMO related page
  };

  const getProductType = (): 'HEL' | 'HELOC' => {
    return loanApplication?.selectedProgramType === 'Home Equity Loan' ? 'HEL' : 'HELOC';
  };

  const getVmoStepFootnote = (): string => {
    const currentVmoStep = getVmoStepFromUrl();
    const productType = getProductType();

    if (currentVmoStep === -1) {
      return '';
    }

    try {
      if (currentVmoStep === 0) {
        // same footnote for HEL and HELOC in vmo page
        return (
          (templateConfig as any)?.pages?.vmo?.footnotes?.vmoFootnote?.value ||
          (templateConfig as any)?.pages?.vmo?.footnotes?.vmoFootnote?.HEL ||
          (templateConfig as any)?.pages?.vmo?.footnotes?.vmoFootnote?.HELOC ||
          ''
        );
      } else if (currentVmoStep === 1) {
        return (templateConfig as any)?.pages?.vmo?.footnotes?.lineAmountFootnote?.[productType] || '';
      } else if (currentVmoStep === 2) {
        // Draw Amount - only for HELOC products
        return (templateConfig as any)?.pages?.vmo?.footnotes?.drawAmountFootnote?.HELOC || '';
      }
    } catch (error) {}
    return '';
  };

  const footnoteText = getVmoStepFootnote();
  if (!footnoteText) {
    return null;
  }

  return (
    <VmoFootnoteContainer className="vmo-footnote">
      <SafeHTML tag="div" html={footnoteText} className="vmo-footnote-content" />
    </VmoFootnoteContainer>
  );
};
